import { getSongDetail, getLyric, getSimiPlaylist, getSimiSong } from '@/services/player'
import {
    changePlayList,
    changeCurrentSongIndex,
    changeCurrentSong,
    changeLyricList,
    changeSimiPlaylist,
    changeSimiSongs,
} from './reducer'
import type { AppDispatch } from '@/store'
import { parseLyric } from '@/utils/format-utils'
import random from 'lodash/random'

const changeCurrentSongAction = tag => {
    return (dispatch: AppDispatch, getState) => {
        // 歌曲类型
        const sequence = getState().player.sequence
        // 歌曲列表
        const playList = getState().player.playList
        // 当前歌曲索引
        let currentSongIndex = getState().player.currentSongIndex

        switch (sequence) {
            case 1:
                // 随机播放
                let randomIndex = -1
                while (randomIndex === currentSongIndex) {
                    randomIndex = random(0, playList.length)
                }
                currentSongIndex = randomIndex
                break
            default:
                // 上下一首
                currentSongIndex += tag
                if (currentSongIndex >= playList.length) {
                    currentSongIndex = 0
                }
                if (currentSongIndex < 0) {
                    currentSongIndex = playList.length - 1
                }
                break
        }

        const currentSong = playList[currentSongIndex]
        dispatch(changeCurrentSong(currentSong))
        dispatch(changeCurrentSongIndex(currentSongIndex))
        dispatch(changeLyricAction(currentSong.id))
    }
}

// 根据id或者歌曲详情
const getSongDetailAction = id => {
    return (dispatch: AppDispatch, getState) => {
        const playList = getState().player.playList
        // 判断是否已经存在播放列表
        const songIndex = playList.findIndex(item => item.id === id)
        if (songIndex !== -1) {
            // 存在
            const song = playList[songIndex]
            dispatch(changeCurrentSong(song))
            dispatch(changeCurrentSongIndex(songIndex))
            dispatch(changeLyricAction(song.id))
        } else {
            // 不存在，需要重新请求
            getSongDetail(id).then(res => {
                const song = res.songs && res.songs[0]
                if (!song) return

                // 1. 将最新请求到的歌曲添加到播放列表中
                const newPlayList = [...playList]
                newPlayList.push(song)

                dispatch(changePlayList(newPlayList))
                dispatch(changeCurrentSong(song))
                dispatch(changeCurrentSongIndex(newPlayList.length - 1))
                dispatch(changeLyricAction(song.id))
            })
        }
    }
}

const changeLyricAction = id => {
    return dispatch => {
        getLyric(id).then(res => {
            const lyric = res.lrc?.lyric
            if (lyric) {
                const lyricList = parseLyric(lyric)
                dispatch(changeLyricList(lyricList))
            }
        })
    }
}

const changeSimiPlaylistAction = () => {
    return (dispatch, getState) => {
        const id = getState().player.currentSong?.id
        if (!id) return

        getSimiPlaylist(id).then(res => {
            dispatch(changeSimiPlaylist(res.playlists))
        })
    }
}

const changeSimiSongAction = () => {
    return (dispatch, getState) => {
        const id = getState().player.currentSong?.id
        if (!id) return

        getSimiSong(id).then(res => {
            dispatch(changeSimiSongs(res.songs))
        })
    }
}

export {
    changeCurrentSongAction,
    getSongDetailAction,
    changeLyricAction,
    changeSimiPlaylistAction,
    changeSimiSongAction,
}
